import script from "./PollWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./PollWidget.vue?vue&type=script&setup=true&lang=js"

import "./PollWidget.vue?vue&type=style&index=0&id=16764544&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16764544"]])

export default __exports__